(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-description"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('fc-product-description')) {
    customElements.define('fc-product-description', class extends HTMLElement {
      connectedCallback() {
        const root = this.querySelector('[style*="max-width:1100px"]');
        if (!root || root.dataset.fcOrganized) return;
        root.dataset.fcOrganized = 'true';
        const nodes = [...root.childNodes];
        let body = null;
        for (const node of nodes) {
          if (node.nodeType === 1 && node.tagName === 'H3') {
            const details = document.createElement('details');
            const summary = document.createElement('summary');
            summary.innerHTML = node.innerHTML;
            body = document.createElement('div');
            body.className = 'fc-detail-body';
            details.append(summary, body);
            root.insertBefore(details, node);
            node.remove();
          } else if (body) {
            body.append(node);
          }
        }
      }
    });
  }
  } catch(e) { console.error(e); }
})();

})();
